<template>
  <el-dialog
    :visible.sync="showDetailDialog"
    width="100%"
    v-loading="logLoadIng"
    append-to-body
    fullscreen
  >
    <div id="map" style="height: 100%; width: 100%"></div>
  </el-dialog>
</template>
<script>
import mapboxgl from "mapbox-gl";
import turf from "turf";
import Cookies from "js-cookie";
export default {
  name: "mapLog",
  props: ["dialogTitle", "ifAudit", "ifRejected"],
  data() {
    return {
      showDetailDialog: false,
      marker: null,
      logLoadIng:false
    };
  },
  beforeDestroy() {
    this.GLOBAL.map.remove();
    this.GLOBAL.map = null;
  },
  methods: {
    // 打开详情弹窗
    dialogOpen(lnglat) {
      this.showDetailDialog = true;
      this.clearMarker(); //清除标记
      if (this.GLOBAL.map) {
        this.fitBounds(lnglat);
      } else {
        this.initMap(lnglat);
      }
    },
    initMap(lnglat) {
      let _that = this;
      this.logLoadIng = true;
      this.$axios
        .get(process.env.MAPID)
        .then((res) => {
          let map = new mapboxgl.Map({
            container: "map",
            style: res.data,
            maxZoom: 17.99,
            center: lnglat,
            zoom: 10,
            transformRequest: (url, resourceType) => {
              if (
                url.includes("mse.gykj.com.cn") ||
                url.includes("mse.agribigdata.com.cn")
              ) {
                return {
                  url: url,
                  headers: { Authorization: Cookies.get("token") },
                };
              } else {
                return {
                  url: url,
                };
              }
            },
          });

          map.on("load", () => {
            //初始化定位
            this.fitBounds(lnglat);
            map.setLayoutProperty("农户地块标注", "visibility", "none");
            map.setLayoutProperty("轨迹线", "visibility", "none");
            this.logLoadIng = false;
          });
          this.GLOBAL.map = map;

          //防止canvas渲染不完整
          map.on("styledata", () => {
            map.resize();
          });

          //导航条
          map.addControl(new mapboxgl.NavigationControl(), "bottom-left");
          //比例尺
          map.addControl(
            new mapboxgl.ScaleControl({ maxWidth: 80, unit: "metric" }),
            "bottom-left"
          );
        })
        .catch((error) => {
          console.log(error);
          this.logLoadIng = false;
        });
    },
    fitBounds(lnglat) {
      this.marker = new mapboxgl.Marker({
        draggable: false,
      })
        .setLngLat(lnglat)
        .addTo(this.GLOBAL.map);
      this.GLOBAL.map.flyTo({
        center: lnglat,
        zoom: 15,
      });
    },
    clearMarker() {
      if (this.marker) {
        this.marker.remove();
        this.marker = null;
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  height: 94%;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/studio/subject/libraryListReviewed/mapLog.vue